import http from '@/utils/http'

export const loadNodes = (params = {}) => http.get('/kuiper/nodes', { params })

export const viewNode = (id) => http.get(`/kuiper/nodes/${id}`)

export const createNode = (body = {}) => http.post('/kuiper/nodes', body)

export const updateNode = (id, body = {}) => http.put(`/kuiper/nodes/${id}`, body)

export const deleteNode = (id) => http.delete(`/kuiper/nodes/${id}`)

export const importRuleset = (nodeID, body = {}) => http.post(`/kuiper/${nodeID}/ruleset/import`, body)

export const exportRuleset = (nodeID) => http.post(`/kuiper/${nodeID}/ruleset/export`)

export default {}
